module.exports = __webpack_public_path__ + "img/abt-1.30da5428.png";